import React from 'react';

import { IIconRotatableProps } from 'assets/icons/IconProps';

export const WhiteIconAI = ({
  width = 24,
  height = 24,
  additionalStyle,
  rotate,
  margin,
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    style={{
      animation: `spin ${rotate}s linear infinite`,
      transformOrigin: 'center center',
      margin: margin,
      ...additionalStyle,
    }}
  >
    <path
      d="M8.80087 5.60285C9.09593 4.85471 10.1547 4.85471 10.4498 5.60285L11.2848 7.71988C11.8252 9.09035 12.91 10.1752 14.2805 10.7156L16.3976 11.5506C17.1457 11.8457 17.1457 12.9045 16.3976 13.1995L14.2805 14.0345C12.91 14.575 11.8252 15.6598 11.2848 17.0303L10.4498 19.1473C10.1547 19.8954 9.09593 19.8954 8.80087 19.1473L7.96592 17.0303C7.42542 15.6598 6.34059 14.575 4.97013 14.0345L2.8531 13.1995C2.10496 12.9045 2.10496 11.8457 2.8531 11.5506L4.97013 10.7156C6.34059 10.1752 7.42542 9.09035 7.96592 7.71988L8.80087 5.60285Z"
      stroke="white"
      strokeWidth="2.13"
    />
    <path
      d="M16.6488 2.50216C16.7595 2.22161 17.1566 2.22161 17.2672 2.50216L17.5802 3.29605C17.783 3.80997 18.1898 4.21678 18.7037 4.41947L19.4976 4.73257C19.7781 4.84322 19.7781 5.24027 19.4976 5.35092L18.7037 5.66403C18.1898 5.86671 17.783 6.27353 17.5802 6.78745L17.2672 7.58133C17.1566 7.86188 16.7595 7.86188 16.6488 7.58133L16.3358 6.78745C16.133 6.27353 15.7262 5.86671 15.2123 5.66403L14.4184 5.35092C14.1379 5.24027 14.1379 4.84322 14.4184 4.73257L15.2123 4.41947C15.7262 4.21678 16.133 3.80997 16.3358 3.29605L16.6488 2.50216Z"
      stroke="white"
      strokeWidth="1.13"
    />
  </svg>
);
